"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinimalCtaBanner = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.bind");

var _palette = require("@artsy/palette");

var _Analytics = require("../Artsy/Analytics");

var Schema = _interopRequireWildcard(require("../Artsy/Analytics/Schema"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SlideTransition = _interopRequireDefault(require("./Animation/SlideTransition"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _dec, _dec2, _class, _class2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var MinimalCtaBanner = (_dec = (0, _Analytics.track)({
  context_module: Schema.ContextModule.MinimalCtaBanner
}), _dec2 = (0, _Analytics.track)({
  action_type: Schema.ActionType.Click,
  action_name: Schema.ActionName.Dismiss,
  subject: "dismiss auth banner for editorial cta on mobile",
  intent: Schema.ActionName.ViewEditorial,
  flow: "authentication"
}), _dec(_class = (_class2 = (_temp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MinimalCtaBanner, _React$Component);

  function MinimalCtaBanner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MinimalCtaBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MinimalCtaBanner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dismissed: false
    });

    return _this;
  }

  _createClass(MinimalCtaBanner, [{
    key: "dismissCta",
    value: function dismissCta() {
      this.setState({
        dismissed: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var ctaBanner = _react.default.createElement(_SlideTransition.default, {
        in: this.props.show,
        timeout: {
          enter: 10,
          exit: 250
        },
        height: this.props.height
      }, _react.default.createElement(BannerContainer, {
        position: this.props.position,
        backgroundColor: this.props.backgroundColor
      }, _react.default.createElement(Banner, {
        textColor: this.props.textColor
      }, _react.default.createElement("a", {
        href: this.props.href
      }, _react.default.createElement(_palette.Sans, {
        size: "3",
        weight: "medium",
        my: 0.5
      }, _react.default.createElement("p", null, this.props.copy))), _react.default.createElement(IconContainer, {
        onClick: this.dismissCta.bind(this)
      }, _react.default.createElement(_Icon.default, {
        name: "close",
        color: this.props.textColor,
        fontSize: "16px",
        style: {
          cursor: "pointer"
        }
      })))));

      return !this.state.dismissed ? ctaBanner : _react.default.createElement("div", null);
    }
  }]);

  return MinimalCtaBanner;
}(_react.default.Component), _temp), (_applyDecoratedDescriptor(_class2.prototype, "dismissCta", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "dismissCta"), _class2.prototype)), _class2)) || _class);
exports.MinimalCtaBanner = MinimalCtaBanner;

var BannerContainer = _styledComponents.default.div.attrs({}).withConfig({
  displayName: "MinimalCtaBanner__BannerContainer",
  componentId: "sc-5otm23-0"
})(["width:100%;height:inherit;background-color:", ";display:flex;position:fixed;z-index:99;", ";"], function (props) {
  return props.backgroundColor || "white";
}, function (props) {
  if (props.position === "bottom") return "bottom: 0px;";
  if (props.position === "top") return "top: 0px;";
});

var Banner = _styledComponents.default.div.attrs({}).withConfig({
  displayName: "MinimalCtaBanner__Banner",
  componentId: "sc-5otm23-1"
})(["display:inline-flex;align-items:center;height:100%;width:100%;padding:10px 10px;a{color:", ";text-decoration:none;margin:auto auto auto 0;}"], function (props) {
  return props.textColor || "black";
});

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "MinimalCtaBanner__IconContainer",
  componentId: "sc-5otm23-2"
})(["margin-left:auto;"]);
//# sourceMappingURL=MinimalCtaBanner.js.map